import * as React from "react";
import { Dropdown, IDropdownOption, IStackTokens, Stack, ActionButton, StackItem, TextField, IStackStyles, Label } from "@fluentui/react";
import { getLibraryDefaultValues, getListSettings, getSharePointContentTypeFields, getSharePointContentTypes, getUserEffectivePermissions } from "../../../services/SharePointRestServices";
import { ComponentTypes } from "../../../config/config";
import InputMetaDataFactory from "../InputMetadataFactory";
import { SharepointSpServices } from "../../../services/SharepointSpServices";
import { SharePointInputData } from "../../../interfaces/props/SharePointInputData";
import { SharePointInputTypes, SharePointMetadataBooleans } from "../../../config/sharepointConstants";
import Loader from "../../Loader";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../redux";
import { setSavingLocation } from "../../../redux/modules/savingLocation";
import { setIsBusyLoadingMetadata, setIsCheckingForDuplicates } from "../../../redux/modules/savingInBackground";
import { setFile, setFileExpander, setFilesCanOverwrite } from "../../../redux/modules/file";
import { addRegionalSettings } from "../../../redux/modules/regional";
import authModule from "../../../../../utilities/AuthModule";
import { LanguageContext, LocalizationModule } from "../../../../../utilities/LocalizationModule";
import { titleIsUnset } from "../../../helpers/titleMetadata";
import { DefaultValueService } from "../../../services/DefaultValueService";
import { BaseSharepointHelper, SharepointContentTypeHelper } from "../../helpers/sharepointContentTypeHelper";
import { DocubirdCache, internalSharepointName, piiConfig, SharepointFilters, SharePointFolderContentTypeIds, sharePointInternalFileName, sharePointInternalTitleName } from "../../../config/constants";
import { FolderView } from "../../helpers/folderView";
import { willSaveAsPdf } from "../../helpers/stringHelper";
import { useSaveFormat } from "../../_v2/redux/hooks/useSaveFormat";
import { getSelectedExchangeItemsAsync } from "../../helpers/emailMappedFileValues";
import { getContainerSharePointIds, getOneDriveRootDetails } from "../../../services/GraphService"
import savingLocationStructureModule from "../../../../../utilities/SavingLocationStructureModule";
import { logger } from "../../../../../utilities/logger";
import { IOfficeService } from "../../../interfaces/IOfficeService";
import emailMapper, { IMappedValue } from "../../../services/EmailMapper";
import { OutlookService } from "../../../services/OutlookService";
import { OutlookUtils } from "../../../../../utilities/OutlookUtils";
import { axiosRetryGet } from "../../../../../utilities/AxiosRetryUtil";
import { IDocumentSetSettings } from "../../../interfaces/IDocumentSetSettings";
import { IContentType } from "../../../interfaces/IContentType";
import { useFiles } from "../../_v2/redux/hooks/useFiles";
import generalModule from "../../../../../utilities/GeneralModule";
import { setCanViewFolder } from "../../../redux/modules/currentSharepointFolder";
import { FileOption } from "../../../interfaces/IFileOption";
import { editFilePropertiesButtonStyles } from "../../../config/controlStyles";
import { boundField, currentSharepointFolderUserPermissions } from "../../../redux/models/reduxModels";
import { DatasourceFieldHelper } from "../../helpers/dataSourceFieldHelper";
import { ModeEnum } from "../../enums/modeEnum";
import { IFileToUpload } from "../../../interfaces/IFileToUpload";
import { IFilePreCommitResult } from "../../../interfaces/IFilePreCommitResult";
import {
  getDirectoryPermissionIdentity,
  getDirectoryRequestKey,
  getEffectivePermissionDirectory,
  getPermissionScopedUniqueId,
  getOneDriveRootSharePointUniqueId,
  isPermissionRootDirectory,
  isOneDriveRootDirectory,
} from "../../../../../contentManager/Body/helpers/contentManagerDirectoryIdentity";
import { buildCurrentSharepointFolderState } from "../../../../../contentManager/Body/helpers/currentSharepointFolderStateBuilder";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { OneDriveUrlHelper } from "../../helpers/oneDriveUrlHelper";
import { buildDestinationUrl, resolveDestinationUrl } from "../../helpers/urlDestination";
import { DragAndDropHelper } from "../../../../../utilities/DragAndDropHelper";
import { ContentManagerCopyMoveModeEnum } from "../../enums/ContentManagerCopyMoveModeEnum";
import { CacheHelper } from "../../../../../utilities/CacheHelper";
import { ISharePointToEmailMapping } from "../../_v2/redux/api/local/api-local-interfaces";
import { apiFilePreCommitCheck } from "../../../services/ApiService";
import { ILibraryDefault, ILibraryDefaultValue } from "../../../interfaces/ILibraryDefaults";
import { tryDecodeUriComponent } from "../../../../../utilities/EncodeDecode";
import { DatasourceHelper } from "../../helpers/dataSourceHelper";
import { useClientTypeContext } from "../../hooks/useClientTypeContext";
import { formatNameFieldValue } from "../../../services/FileFolderNameExtensions";
import { IMailSendConfig, IMailSendHeaders } from "../../../interfaces/IMailSendPayload";
import useDidMountEffect from "../../../../../utilities/Hooks/useDidMountEffect";
import { getAuthenticatedClient } from "../../../services/GraphClientService";
import { IContainerDisplayNames } from "../../../../../utilities/ContainerHelper";
import { Edit20Regular } from "../../_v2/components/SvgIcons/Edit20Regular";

const multipleMetaUpdateIcon = { iconName: "Edit" };

const inputFieldsStackStyles: React.CSSProperties = {
  paddingBottom: 15
}

const loaderStackStyles: Partial<IStackStyles> = {
  root: { width: "100%", height: "100%", margin: 0, paddingTop: 20, overflow: "auto" }
};

const stackTokens: IStackTokens = {
  childrenGap: 15
};

const undefinedString: string = "_undefined_";

const mapStateToProps = (state: RootState) => {
  return {
    workingDirectories: state.workingDirectories?.workingDirectories,
    isSavingInBackground: state.savingInBackground?.isSavingInBackground,
    currentDirectory:
      state.workingDirectories?.workingDirectories[state.workingDirectories?.workingDirectories?.length - 1],
    files: state.files?.files,
    regionalSettings: state.regionalSettings,
    siteInfo: state.tenantInfo?.sites,
    hiddenMetadataFields: state.tenantInfo?.hiddenMetadataFields,
    reload: state.reload?.toggle,
    currentSharepointFolder: state.currentSharepointFolder,
    tenantReplaceFileNameWithGUID: state.tenantInfo?.replaceFileNameWithGUID,
    tenantDisableFileRename: state.tenantInfo?.disableFileRename,
    datasources: state.tenantInfo?.datasources,
    mode: state.mode?.mode,
    moveTo: state.contentManagerDirectory?.moveTo,
    oneDriveWebUrl: state.user?.oneDriveWebUrl,
    oneDriveRootDetails: state.workingDirectories?.oneDriveRootDetails
  };
};

const mapDispatchToProps = {
  setIsCheckingForDuplicates,
  setSavingLocation,
  setFilesCanOverwrite,
  addRegionalSettings,
  setCanViewFolder,
  setFile,
  setFileExpander,
  setIsBusyLoadingMetadata
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface SaveWithMetaDataProps extends PropsFromRedux {
  updateSharepointMetadataToSave: (value: SharePointInputData[], informationProtectionId: string, changedIndex?: number) => void;
  inputValuesToSave: SharePointInputData[];
  OfficeService?: IOfficeService;
  isInfoMode?: boolean;
  addNameField?: boolean;
  disableNameField?: boolean;
  isCreateFromTemplate?: boolean;
  isInOneDrive?: boolean;
  itemContentTypeId?: string;
  itemWebUrl?: string;
  itemSharepointListId?: string;
  fieldsChanged?: (fields: any[], contentTypeId: string, inputValues?: SharePointInputData[]) => void;
  fieldsLoaded?: () => void;
  selectedIndividualFile?: FileOption;
  setSelectedIndividualFile?: (selectedIndividualFile: FileOption) => void;
  showUpdateIndividualFilesButton?: boolean;
  setIsCMMultipleFilesMetaDataPanelOpen?: (isCMMultipleFilesMetaDataPanelOpen: boolean) => void;
  userItemPermissions?: currentSharepointFolderUserPermissions;
  showSelectedFileCount?: boolean;
  isCurrentDirectorySPList?: boolean;
  isBulkEdit?: boolean;
  mailSendConfig?: IMailSendConfig;
  selectedItem?: any;
  containerDisplayNames?: IContainerDisplayNames;
  templateContentTypeName?: string;
}

const SaveWithMetaData: React.FunctionComponent<SaveWithMetaDataProps> = ({
  updateSharepointMetadataToSave,
  inputValuesToSave,
  setSavingLocation,
  setIsCheckingForDuplicates,
  setCanViewFolder,
  workingDirectories,
  currentDirectory,
  files,
  setFilesCanOverwrite,
  regionalSettings,
  addRegionalSettings,
  siteInfo,
  hiddenMetadataFields,
  OfficeService,
  reload,
  currentSharepointFolder,
  isInfoMode,
  addNameField,
  disableNameField,
  isInOneDrive,
  itemContentTypeId,
  itemWebUrl,
  itemSharepointListId,
  fieldsLoaded,
  fieldsChanged,
  tenantReplaceFileNameWithGUID,
  tenantDisableFileRename,
  isCreateFromTemplate,
  selectedIndividualFile,
  setSelectedIndividualFile,
  showUpdateIndividualFilesButton,
  setIsCMMultipleFilesMetaDataPanelOpen,
  datasources,
  mode,
  setFile,
  moveTo,
  userItemPermissions,
  showSelectedFileCount,
  setFileExpander,
  isCurrentDirectorySPList,
  isBulkEdit,
  mailSendConfig,
  oneDriveWebUrl,
  oneDriveRootDetails,
  setIsBusyLoadingMetadata,
  selectedItem,
  containerDisplayNames,
  templateContentTypeName
}: SaveWithMetaDataProps) => {
  const languageStrings = React.useContext(LanguageContext);
  // Effective save-format flags (per-save pick or the persisted default) for the
  // duplicate-check filename below.
  const { saveMode, convertEmailToPDF } = useSaveFormat();

  const [fileList, setFileList] = React.useState<IFileToUpload[]>(!DragAndDropHelper.isDroppedModeActive ? files : files.filter(f => f.isFileSystemEntry));
  const [selectedFileList, setSelectedFileList] = React.useState<IFileToUpload[]>(fileList?.filter(x => x.isSelected) ?? []);
  const [isLoading, setLoading] = React.useState<boolean>(true);
  const [contentTypes, setContentTypes] = React.useState<IDropdownOption[]>([]);
  const [documentSetSettings, setDocumentSetSettings] = React.useState<IDocumentSetSettings>();
  const [fields, setFields] = React.useState([]);
  const [selectedContentType, setSelectedContentType] = React.useState<IDropdownOption>();

  const [protectionLabels, setProtectionLabels] = React.useState<IDropdownOption[]>([]);
  const [selectedProtectionLabel, setSelectedProtectionLabel] = React.useState<IDropdownOption>();
  const [showProtectionDropdown, setShowProtectionDropdown] = React.useState<boolean>(false);

  const [sharepointService, setSharepointService] = React.useState<SharepointSpServices>(null);
  const clientTypes = useClientTypeContext(containerDisplayNames?.siteId ?? currentDirectory?.siteId);
  // useMemo, NOT a one-shot useState initializer: the client-type context can settle after
  // mount, and a captured verdict would silently ignore it.
  const datasourceFields = React.useMemo<boundField[]>(
    () => DatasourceFieldHelper.getDatasourceFields(datasources, [containerDisplayNames?.siteDisplayName ?? currentDirectory?.siteDisplayName ?? ""], [containerDisplayNames?.libraryDisplayName ?? currentDirectory?.DocumentLibrary ?? currentDirectory?.sharepointList ?? ""], clientTypes),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clientTypes]
  );

  // const [officeFileName, setOfficeFileName] = React.useState<string>(mode === ModeEnum.office && fileList?.length === 1 ? fileList[0].name : "");
  const [selectedFileName, setSelectedFileName] = React.useState<string>(selectedFileList?.length === 1 ? selectedFileList[0].name : "");

  // Used to keep the displayed Title mirroring the Name field across renames.
  // Two name mechanisms exist: the static name field (selectedFileName) and the
  // FileLeafRef metadata field (used in info / create-from-template / multi-file
  // flows); the latter is mirrored at the change source in handleInputChange.
  const titleAutoSetVariants = React.useRef<string[]>(LocalizationModule.getTitleAutoSetVariants());
  const previousFileNameRef = React.useRef<string>(selectedFileName);

  const emailMappings = React.useRef<ISharePointToEmailMapping[]>([]);
  const locationDefaultValues = React.useRef<ILibraryDefaultValue[]>(null);
  const draftEmailHeaders = React.useRef<IMailSendHeaders>(null);

  const { getFilePreCommitCheckAsync } = useFiles();

  const isOneDriveBusiness = React.useRef<boolean>(isInOneDrive
    || (itemWebUrl ?? currentDirectory?.webUrl)?.startsWith(oneDriveRootDetails?.sharePointSiteUrl ?? undefinedString)
    || (itemWebUrl ?? currentDirectory?.webUrl)?.startsWith(oneDriveWebUrl ?? undefinedString)
    || oneDriveWebUrl?.startsWith((itemWebUrl ?? currentDirectory?.webUrl) ?? undefinedString));

  const showStaticNameField: boolean = React.useMemo(() => {
    return !isInfoMode && !isCurrentDirectorySPList && !tenantReplaceFileNameWithGUID && !isBulkEdit;
  }, [isInfoMode, isCurrentDirectorySPList, tenantReplaceFileNameWithGUID, isBulkEdit]);

  React.useEffect(() => {
    setIsLoading(true);
    setIsCheckingForDuplicates(true);
    const setupAsyncWrapper = async () => {
      try {
        const accessToken = !isOneDriveBusiness.current
          ? await authModule.getSharePointAccessToken()
          : await authModule.getOneDriveAccessToken();

        const webUrl: string = !isOneDriveBusiness.current
          ? (itemWebUrl ?? currentDirectory.webUrl)
          : OneDriveUrlHelper.getSiteUrl(itemWebUrl ?? currentDirectory.webUrl);

        const isOneDrive: boolean = isOneDriveBusiness.current
          || (itemWebUrl ?? currentDirectory?.webUrl)?.startsWith(oneDriveRootDetails?.sharePointSiteUrl ?? undefinedString)
          || webUrl?.startsWith(oneDriveWebUrl ?? undefinedString)
          || oneDriveWebUrl?.startsWith(webUrl ?? undefinedString);

        if (isOneDrive && !isOneDriveBusiness.current) {
          isOneDriveBusiness.current = true;
        }

        const sharepointSpService = new SharepointSpServices(webUrl, accessToken);
        setSharepointService(sharepointSpService);
        const regionalSettingsAvailable = regionalSettings[webUrl];
        if (!regionalSettingsAvailable) {
          const regionalSettings = !isOneDrive ? await sharepointSpService.getSiteRegionalSettings() : null;
          if (regionalSettings) {
            addRegionalSettings({ ...regionalSettings, webUrl: webUrl });
          }
        }

        // await Promise.all([
        //   getProtectionLabelsGraph(),
        //   getContentTypes(accessToken),
        // ]);
        const locationUniqueId: string = await getContentTypes(accessToken);

        if (!isInfoMode) {
          if (!currentDirectory.isSaveLocationStructureSet) {
            savingLocationStructureModule.setSavingLocationStructure(workingDirectories);
          }

          setSavingLocation({
            display: currentDirectory.fileTitle ?? currentDirectory.displayName,
            webUrl: webUrl,
            directory: currentDirectory.directory,
            documentLibrary: currentDirectory.DocumentLibrary,
            sharePointListId: currentDirectory.sharePointListId ?? itemSharepointListId,
            sharePointUniqueId: locationUniqueId,
            teamId: workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId,
            channelId: workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId
          }, isOneDrive);
        }

        setIsLoading(false);

        if (fieldsLoaded) {
          fieldsLoaded();
        }

        if (!isInfoMode && !tenantReplaceFileNameWithGUID) {
          if (fileList?.length > 1) {
            const destUrl = isOneDrive
              ? buildDestinationUrl(oneDriveWebUrl ?? webUrl, currentDirectory.directory)
              : await resolveDestinationUrl({ ...currentDirectory, webUrl }, { isOneDrive: false });

            const preComitResult = await getFilePreCommitCheckAsync(
              files,
              {
                autoFolderCreation: !(new FolderView(siteInfo, currentDirectory).canViewFolder()),
                destinationUrl: destUrl,
                siteUrl: isOneDrive ? OneDriveUrlHelper.getSiteUrl(webUrl) : webUrl
              },
              isOneDrive
            );

            if (preComitResult?.some(file => file?.isDuplicate === true)) {
              setFileExpander(true);
            }
          }
          else if (selectedFileList?.length === 1) {
            setFile(await checkFile(selectedFileList[0].name));
          }
        }
      } catch (e) {
        logger(e, "SaveToSharepoint.tsx (useEffect 1)");
        setIsLoading(false);
        if (fieldsLoaded) {
          fieldsLoaded();
        }
      }
      setIsCheckingForDuplicates(false);
    };
    setupAsyncWrapper();
  }, [reload, selectedItem]);

  React.useEffect(() => {
    const updatedFileList = !DragAndDropHelper.isDroppedModeActive ? files : files.filter(f => f.isFileSystemEntry);
    const updatedSelectedFileList = updatedFileList?.filter(x => x.isSelected) ?? [];
    setFileList(updatedFileList);
    setSelectedFileList(updatedFileList?.filter(x => x.isSelected) ?? []);
    setSelectedFileName(updatedSelectedFileList?.length === 1 ? updatedSelectedFileList[0].name : "");
  }, [files]);

  useDidMountEffect(() => {
    let isCurrentCall = true;
    let debounceTimer;

    debounceTimer = setTimeout(async () => {
      if (!isInfoMode && selectedFileName) {
        const checkedFile: IFileToUpload = await checkFile(selectedFileName);
        if (isCurrentCall) {
          setFile(checkedFile);
        }
      }
    }, 900);

    return () => {
      isCurrentCall = false;
      clearTimeout(debounceTimer);
    };
  }, [isInfoMode, selectedFileName]);

  // Keep the displayed Title mirroring the Name field, including renames, so the
  // shown Title matches what BasePersistor will persist. Two flows feed the name:
  //  - the static name field (selectedFileName), used when saving/uploading;
  //  - the FileLeafRef metadata field, used in info / create-from-template flows.
  // syncTitleToName only updates the Title while it is still mirroring the name
  // (unset, or equal to the prior name); a Title the user typed is never clobbered.
  const nameFieldValue = inputValuesToSave?.find(x => x.internalName === sharePointInternalFileName)?.value;

  // Flows whose Name lives in the FileLeafRef metadata field (rather than the
  // static name field) and where the Title should track it: create-from-template
  // (New/Templates) and the per-file multi-file metadata panel. Existing-file
  // property edits pass neither flag and are intentionally left untouched.
  const shouldSyncTitleFromNameField = isCreateFromTemplate || !!selectedIndividualFile;

  useDidMountEffect(() => {
    const previousName = previousFileNameRef.current;

    // Static name field flow (single-file save / upload). Multi-file shows the
    // auto-set placeholder and resolves per file at save, so skip it here.
    if (isInfoMode || selectedFileList?.length !== 1 || !selectedFileName) {
      return;
    }
    previousFileNameRef.current = selectedFileName;
    syncTitleToName(previousName, selectedFileName);
  }, [selectedFileName]);

  // Seed an unset Title from the FileLeafRef Name on load (e.g. create-from-
  // template), so the displayed Title matches what will be saved before any edit.
  // Renames are mirrored at the change source in handleInputChange; passing the
  // name as both args makes this a no-op once the Title already equals the name.
  useDidMountEffect(() => {
    if (!shouldSyncTitleFromNameField || !nameFieldValue) {
      return;
    }
    syncTitleToName(nameFieldValue, nameFieldValue);
  }, [nameFieldValue]);

  // React.useEffect(() => {
  //   //check if there are any files in the list of FileToUpload that are compatible with protection labels
  //   try {
  //     if (protectionLabels?.length > 0) {
  //       const someCompatible = fileList
  //         .filter(f => f.isSelected)
  //         .some(f => isCompatibleType(f.extension));
  //       setShowProtectionDropdown(someCompatible);
  //       if (!someCompatible) {
  //         setSelectedProtectionLabel({
  //           key: null,
  //           text: "",
  //           title: ""
  //         });
  //       }
  //     } else {
  //       setShowProtectionDropdown(false);
  //       setSelectedProtectionLabel({
  //         key: null,
  //         text: "",
  //         title: ""
  //       });
  //     }
  //   } catch (e) {
  //     logger(e, "SaveToSharepoint.tsx (useEffect 2)");
  //   }

  // }, [fileList, protectionLabels, selectedIndividualFile]);

  useDidMountEffect(() => {
    const asyncWrapper = async () => {
      await getMailExchangeInformation();

      emailMappings.current = [];
      let inputValuesToSaveFields: SharePointInputData[] = await Promise.all(fields.map(async (item, index) => {
        return await setupInputValues(item, index);
      }));

      //Typecasting here, because ".key" can be int or string
      const sensitivityLabelId: string = selectedProtectionLabel ? selectedProtectionLabel.key as string : null;
      updateSharepointMetadataToSave(inputValuesToSaveFields, sensitivityLabelId);
    }

    asyncWrapper();
  }, [OfficeService]);

  const setIsLoading = (isLoading: boolean) => {
    setLoading(isLoading);
    setIsBusyLoadingMetadata(isLoading);
  }

  const checkFile = async (selectedFileName: string) => {
    let file: IFileToUpload = { ...(selectedFileList[0]), name: selectedFileName };
    let preCommitResult: IFilePreCommitResult;
    if (selectedFileName) {
      setIsCheckingForDuplicates(true);
      try {
        const saveLocation: IPageSettings = savingLocationStructureModule.getSavingDestination() ?? currentDirectory;

        const isOneDrive: boolean = isOneDriveBusiness.current
          || (itemWebUrl ?? currentDirectory?.webUrl)?.startsWith(oneDriveRootDetails?.sharePointSiteUrl ?? undefinedString)
          || saveLocation.webUrl?.startsWith(oneDriveWebUrl ?? undefinedString)
          || oneDriveWebUrl?.startsWith(saveLocation.webUrl ?? undefinedString);

        if (isOneDrive && !isOneDriveBusiness.current) {
          isOneDriveBusiness.current = true;
        }

        if (saveLocation) {
          const destUrl = isOneDrive
            ? buildDestinationUrl(oneDriveWebUrl ?? saveLocation.webUrl, saveLocation.directory)
            : await resolveDestinationUrl(saveLocation, { isOneDrive: false });

          preCommitResult = await apiFilePreCommitCheck({
            accessToken: !isOneDrive ? await authModule.getSharePointAccessToken() : await authModule.getOneDriveAccessToken(),
            autoFolderCreation: isOneDrive ? false : !(new FolderView(siteInfo, saveLocation).canViewFolder()),
            fileName: willSaveAsPdf(file, convertEmailToPDF, saveMode) ? `${file.name}.pdf` : `${file.name}.${file.extension}`,
            destinationUrl: destUrl,
            siteUrl: isOneDrive ? OneDriveUrlHelper.getSiteUrl(saveLocation.webUrl) : saveLocation.webUrl
          });
        }
      } catch (error) {
        logger(error, "SaveToSharepoint.tsx (checkFile)");
      }
      setIsCheckingForDuplicates(false);
    }

    if (!preCommitResult) {
      preCommitResult = { exists: false, checkedOut: false, checkedOutBy: null, locked: false, lockedBy: null };
    }

    const fileToSet: IFileToUpload = {
      ...file,
      name: selectedFileName,
      isDuplicate: preCommitResult.exists,
      filePreCommitResult: preCommitResult
    }

    return fileToSet;
  }

  const getMailExchangeInformation = async (mailSendConfig?: IMailSendConfig) => {
    if (mode === ModeEnum.mailCompose) {
      const draftMessageDetails = await OutlookUtils.getDraftMassage();
      if (draftMessageDetails) {
        try {
          let mailboxAddress: string | undefined;
          if (Office.context?.mailbox?.item?.getSharedPropertiesAsync) {
            mailboxAddress = await OutlookUtils.getMailboxAddress()
          }

          const mailToSendHeaders: IMailSendHeaders = {
            subject: draftMessageDetails.subject,
            from: mailboxAddress ?? Office.context?.mailbox?.userProfile?.emailAddress ?? "",
            bcc: draftMessageDetails.bccRecipients?.map(bcc => bcc.emailAddress?.address),
            cc: draftMessageDetails.ccRecipients?.map(cc => cc.emailAddress?.address),
            categories: [],
            to: draftMessageDetails.toRecipients?.map(t => t.emailAddress?.address),
            date: new Date(),
            conversationId: draftMessageDetails.conversationId,
            conversationIndex: draftMessageDetails.conversationIndex,
            internetMessageId: draftMessageDetails.internetMessageId,
            importance: draftMessageDetails.importance,
            hasAttachments: draftMessageDetails.hasAttachments
          }
          draftEmailHeaders.current = mailToSendHeaders;
        } catch (error) {
          logger(error, "SaveToSharepoint.tsx (getDraftMailDetails)");
        }
      }
    }
    else {
      let mailItemRestId: string;
      let mailItemRestUrl: string;
      let token: string;

      if (!mailSendConfig) {
        const itemId = !generalModule.isInConentMangerMode() && generalModule.getIsOfficeJSAvailable()
          ? Office.context?.mailbox?.item?.itemId
          : null;

        if (itemId) {
          mailItemRestId = OutlookService.getItemRestId(itemId);
          mailItemRestUrl = OutlookUtils.ewsOnlySupport ? await OutlookUtils.getRestURL() : undefined;
          token = OutlookUtils.ewsOnlySupport ? await OutlookUtils.getOutlookToken() : undefined;
        }
      }
      else {
        mailItemRestId = mailSendConfig.mailItemRestId;
        mailItemRestUrl = mailSendConfig.restURL;
        token = mailSendConfig.outlookToken;
      }

      if (mailItemRestId) {
        try {
          let mailDetails: any;
          if (!OutlookUtils.ewsOnlySupport) {
            const mailboxResource: string = Office.context?.mailbox?.item?.getSharedPropertiesAsync
              ? `users/${await OutlookUtils.getMailboxAddress()}`
              : "me";

            const client = getAuthenticatedClient(await authModule.getGraphAccessToken());
            mailDetails = await client.api(`/${mailboxResource}/messages/${mailItemRestId}`)
              .select("sentDateTime,receivedDateTime,conversationIndex,hasAttachments,replyTo,importance")
              .get();
          }
          // else if (mailItemRestUrl && token) {
          //   const updateMessageUrl = mailItemRestUrl + "/messages/" + mailItemRestId;
          //   const headers = {
          //     "Authorization": "Bearer " + token
          //   }
          //   mailDetails = (await axiosRetryGet(updateMessageUrl, {
          //     headers: headers
          //   }))?.data;
          // }

          if (mailDetails) {
            emailMapper.updateValuesFromExchange(mailDetails);
          }

        } catch (error) {
          logger(error, "SaveToSharepoint.tsx (getMailExchangeInformation)");
        }
      }
    }
  }

  // const isCompatibleType = (extension: string): boolean => {
  //   const objVals = Object.keys(InfoProtectionFileTypeEnum);
  //   let any = objVals.filter((value) => {
  //     return value.toLowerCase() === extension?.trim().toLowerCase()
  //   })
  //   return any.length > 0;
  // }

  const getContentTypes = async (accessToken: string): Promise<string> => {
    if (!isOneDriveBusiness.current) {
      const documentSetContentTypeId: string =
        currentDirectory?.parentDocumentSetContentTypeId
        ??
        workingDirectories?.find(dir => dir?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet))?.contentTypeId;

      let [contentTypeResult, documentSetSettings, libraryDefaults, locationUniqueId] = await Promise.all(
        [
          getSharePointContentTypes(accessToken, itemWebUrl ?? currentDirectory.webUrl, itemSharepointListId ?? currentDirectory.sharePointListId, documentSetContentTypeId ? true : false),
          getDocumentSetSettings(accessToken, documentSetContentTypeId),
          !isBulkEdit && getLibraryDefaultValues(accessToken, itemWebUrl ?? currentDirectory?.webUrl, currentDirectory?.directory),
          getLibrarySettings(),
          getMailExchangeInformation(mailSendConfig)
        ]
      );

      setLocationDefaultValues(libraryDefaults);

      if (contentTypeResult?.length > 0) {
        const isFolderOrDocumentSetContentType: boolean = itemContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder);
        let contentTypes: IContentType[];
        if (!isFolderOrDocumentSetContentType) {
          contentTypes = SharepointContentTypeHelper.mapDocumentContentTypes(contentTypeResult);
        }
        else {
          contentTypes = SharepointContentTypeHelper.mapFolderOrDocumentSetContentTypes(contentTypeResult, itemContentTypeId);
        }

        if (!isFolderOrDocumentSetContentType && documentSetSettings?.allowedContentTypeIds?.length > 0) {
          let allowedContentTypes = contentTypes.filter(contentType => documentSetSettings.allowedContentTypeIds.some(allowedContentType => allowedContentType === contentType.parent?.id));
          if (allowedContentTypes.length > 0) { // Ensure to always show content types should filter not return any results
            contentTypes = allowedContentTypes;
          }
        }

        let availableContentTypeDropdownOptions: IDropdownOption[];
        if (isBulkEdit && !itemContentTypeId) {
          availableContentTypeDropdownOptions = [{ key: "", text: "" }].concat(contentTypes.map(contentType => ({ key: contentType.id, text: contentType.name })));
        }
        else {
          availableContentTypeDropdownOptions = contentTypes.map(contentType => ({ key: contentType.id, text: contentType.name }));
        }
        setContentTypes(availableContentTypeDropdownOptions);

        if (availableContentTypeDropdownOptions.length > 0) {
          let defaultSelectedContentType: IDropdownOption;

          if (!isBulkEdit || itemContentTypeId) {
            if (isCreateFromTemplate && templateContentTypeName?.trim()) {
              // Pre-select the content type whose name matches the template library's "Content Type" column value.
              const templateContentTypeNameToMatch: string = templateContentTypeName.trim().toLowerCase();
              defaultSelectedContentType = availableContentTypeDropdownOptions.find(contentType => contentType.text?.trim().toLowerCase() === templateContentTypeNameToMatch);
            }
            else if (!itemContentTypeId
              && !isInfoMode
              && mode !== ModeEnum.office
              && !DragAndDropHelper.isDroppedModeActive
              && (!generalModule.isInConentMangerMode() || moveTo.mode === ContentManagerCopyMoveModeEnum.CopySelectedEmails || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails)
            ) {
              const mappedContentTypes: string[] = emailMapper.findMappedColumnNames("contentType");
              if (mappedContentTypes) {
                defaultSelectedContentType = availableContentTypeDropdownOptions.find(contentType => mappedContentTypes.some(mappedContentType => contentType.text.toLowerCase() === mappedContentType.toLowerCase()));
              }
            }
            else {
              defaultSelectedContentType = availableContentTypeDropdownOptions.find(contentType => contentType.key == itemContentTypeId);
            }

            if (!defaultSelectedContentType) {
              defaultSelectedContentType = availableContentTypeDropdownOptions.find(contentType => (contentType.key as string)?.startsWith(SharePointFolderContentTypeIds.document)) ?? availableContentTypeDropdownOptions[0];
            }

            setSelectedContentType(defaultSelectedContentType);
          }
          else {
            defaultSelectedContentType = availableContentTypeDropdownOptions[0];
          }

          const { fields, inputValuesToSaveFields } = await getFields(accessToken, documentSetSettings?.sharedFieldIds, defaultSelectedContentType.key as string, defaultSelectedContentType.text);
          if (fieldsChanged) fieldsChanged(fields, defaultSelectedContentType.key as string, inputValuesToSaveFields);
        }
      }

      return locationUniqueId;
    } else {
      const [{ fields }, uniqueId] = await Promise.all([
        getFields(accessToken, documentSetSettings?.sharedFieldIds),
        getContainerUniqueId()
      ]);
      if (fieldsChanged) fieldsChanged(fields, '');
      return uniqueId;
    }
  };

  const getContainerUniqueId = async (): Promise<string> => {
    const permissionDirectory = getEffectivePermissionDirectory({
      currentDirectory,
      workingDirectories,
    });
    let uniqueId = getPermissionScopedUniqueId({
      currentDirectory: permissionDirectory,
      sharePointUniqueId: permissionDirectory?.sharePointUniqueId,
    });

    if (permissionDirectory && !uniqueId && !workingDirectories?.some(x => x.type === ComponentTypes.SharePointList)) {
      if (isOneDriveRootDirectory(permissionDirectory)) {
        return getOneDriveRootSharePointUniqueId({
          currentDirectory: permissionDirectory,
          oneDriveRootDetails,
        }) ?? (await getOneDriveRootDetails())?.sharePointItemId;
      }

      if (isPermissionRootDirectory(permissionDirectory)) {
        return undefined;
      }

      const driveId: string = !permissionDirectory.parentId ? permissionDirectory.id : permissionDirectory.parentId;
      const itemId: string = !permissionDirectory.parentId ? null : permissionDirectory.id;
      const destSharePointIds = await getContainerSharePointIds(driveId, itemId);
      if (destSharePointIds) {
        uniqueId = getPermissionScopedUniqueId({
          currentDirectory: permissionDirectory,
          sharePointUniqueId: destSharePointIds.listItemUniqueId,
        });
      }
    }
    return uniqueId;
  }

  const getLibrarySettings = async (): Promise<string> => {
    const uniqueId: string = await getContainerUniqueId();

    if (!generalModule.isInConentMangerMode()) {
      const accessToken = !isOneDriveBusiness.current
        ? await authModule.getSharePointAccessToken()
        : await authModule.getOneDriveAccessToken();

      const webUrl: string = !isOneDriveBusiness.current
        ? (itemWebUrl ?? currentDirectory.webUrl)
        : OneDriveUrlHelper.getSiteUrl(itemWebUrl ?? currentDirectory.webUrl);

      const permissionDirectory = getEffectivePermissionDirectory({
        currentDirectory,
        workingDirectories,
      });
      const listId = permissionDirectory?.sharePointListId || currentDirectory?.sharePointListId || itemSharepointListId;
      const permissionUniqueId = getPermissionScopedUniqueId({
        currentDirectory: permissionDirectory,
        sharePointUniqueId: uniqueId,
      });

      const refreshSettings = currentSharepointFolder?.sharepointListId !== listId;
      const refreshPermissions = (!currentSharepointFolder?.userPermissions && !userItemPermissions)
        || currentSharepointFolder?.sharepointListId !== listId
        || currentSharepointFolder?.sharePointUniqueId !== permissionUniqueId;

      const [settings, permissions] = await Promise.all([
        refreshSettings && getListSettings(accessToken, webUrl, listId),
        refreshPermissions && getUserEffectivePermissions(accessToken, webUrl, listId, permissionUniqueId)
      ]);

      if (refreshSettings || refreshPermissions) {
        const directoryIdentity = getDirectoryPermissionIdentity({
          currentDirectory: permissionDirectory ?? currentDirectory,
          resolvedSharePointUniqueId: permissionUniqueId,
        });
        const directoryRequestKey = getDirectoryRequestKey({
          currentDirectory: permissionDirectory ?? currentDirectory,
        });
        const nextPermissions = (refreshPermissions && permissions) ? permissions : currentSharepointFolder?.userPermissions;
        const identityMatchesExisting = currentSharepointFolder?.permissionIdentityKey === directoryIdentity.key;

        setCanViewFolder(buildCurrentSharepointFolderState({
          existingFolderState: currentSharepointFolder,
          folderUpdate: {
            sharepointListId: listId,
            sharePointUniqueId: permissionUniqueId,
            canCreateFolder: (refreshSettings && settings) ? settings.EnableFolderCreation : currentSharepointFolder?.canCreateFolder,
            contentTypesEnabled: (refreshSettings && settings) ? settings.ContentTypesEnabled : currentSharepointFolder?.contentTypesEnabled,
            enableMinorVersions: (refreshSettings && settings) ? settings.EnableMinorVersions : currentSharepointFolder?.enableMinorVersions,
            disableOpenInApp: (refreshSettings && settings) ? settings.ExcludeFromOfflineClient === true : currentSharepointFolder?.disableOpenInApp,
          },
          directoryIdentity,
          directoryRequestKey,
          permissionState: {
            directoryRequestKey,
            identityKey: directoryIdentity.key,
            resolvedSharePointUniqueId: permissionUniqueId,
            permissions: refreshPermissions
              ? (permissions ?? undefined)
              : (identityMatchesExisting ? nextPermissions : undefined),
            status: refreshPermissions
              ? (permissions ? "loaded" : "failed")
              : (identityMatchesExisting && nextPermissions
                ? "loaded"
                : (directoryIdentity.isComplete ? "loading" : "unknown")),
            errorMessage: refreshPermissions && !permissions ? "Could not load folder permissions." : undefined,
          },
        }));
      }
    }

    return uniqueId;
  }

  const getDocumentSetSettings = async (accessToken: string, documentSetContentTypeId: string): Promise<IDocumentSetSettings> => {
    let documentSetSettings: IDocumentSetSettings;
    if (documentSetContentTypeId) {
      documentSetSettings = await SharepointContentTypeHelper.getDocumentSetSettings(accessToken, currentDirectory.webUrl, currentDirectory.sharePointListId, documentSetContentTypeId);
      setDocumentSetSettings(documentSetSettings);
    }
    return documentSetSettings;
  }

  // const getProtectionLabelsGraph = async () => {
  //   try {
  //     const protectionLabelsGraph = await getProtectionLabels();
  //     //Map protection labels to Options, and add the "None" option
  //     const protectionLabelOptions: IDropdownOption[] = [{
  //       key: null,
  //       text: "",
  //       title: ""
  //     }]
  //       .concat(
  //         protectionLabelsGraph
  //           .map((label, index) => {
  //             return {
  //               key: label.id,
  //               text: label.name,
  //               title: label.tooltip?.length > 0 ? label.tooltip : label.name,
  //             }
  //           }))
  //     //.sort((a, b) => a.key.localeCompare(b.key))
  //     setProtectionLabels(protectionLabelOptions);
  //   } catch (error) {
  //     setProtectionLabels(null);
  //   }
  // }

  const getFields = async (accessToken: string, sharedFieldIds: string[] | undefined, contentTypeId: string = null, contentTypeName: string = null) => {
    if (!isOneDriveBusiness.current) {
      const isInSPList = workingDirectories && workingDirectories.some(x => x.type === ComponentTypes.SharePointList);
      let result = await getSharePointContentTypeFields(
        accessToken,
        itemWebUrl ?? currentDirectory.webUrl,
        itemSharepointListId ?? currentDirectory.sharePointListId,
        contentTypeId,
        isInSPList ? SharepointFilters.metadata.saveSPList : SharepointFilters.metadata.save
      );

      let fields = result.map(BaseSharepointHelper.convertMetadataToFields).filter(field => field);

      if (addNameField && (!tenantDisableFileRename || isCreateFromTemplate)) {
        let nameField = {
          Choices: undefined,
          CurrentValue: null,
          DefaultValue: null,
          Id: "5cc6dc79-3710-4374-b433-61cb4a686c12",
          InternalName: sharePointInternalFileName,
          isValid: true,
          xml: {
            ColName: "nvarchar8",
            DisplayName: languageStrings.Name,
            ID: "{5cc6dc79-3710-4374-b433-61cb4a686c12}",
            Name: "Name",
            ReadOnly: disableNameField === true ? "TRUE" : "FALSE",
            Required: disableNameField === true ? "FALSE" : "TRUE",
            Sealed: "TRUE",
            ShowInEditForm: "TRUE",
            ShowInFileDlg: "FALSE",
            ShowInNewForm: "FALSE",
            SourceID: "http://schemas.microsoft.com/sharepoint/v3",
            StaticName: "Name",
            Type: "Text",
          }
        }

        if (isInfoMode && contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) {
          const contentTypeInputName: string = `${contentTypeName} name`;
          // Stamped with the verdict at schema-build time. KNOWN BOUND: a client-type verdict
          // settling after this build leaves the decoration (picker vs plain name input) as
          // built until the next getFields run - any content-type switch refreshes it, and the
          // hook prefetch makes a post-build settle the cold-cache exception. Patching the
          // stamped field in place from an effect would need contentTypeName/-Id state that
          // only exists inside this build; not worth the fragility for a display-only latch.
          const datasourceItem = DatasourceHelper.getInputDataSource(datasources, contentTypeInputName, [containerDisplayNames?.siteDisplayName ?? currentDirectory?.siteDisplayName ?? ""], [containerDisplayNames?.libraryDisplayName ?? currentDirectory?.DocumentLibrary ?? currentDirectory?.sharepointList ?? ""], clientTypes);
          if (datasourceItem) {
            (nameField.xml as any).ContentTypeInputName = contentTypeInputName;
          }
        }

        fields.unshift(nameField);
      }

      if (hiddenMetadataFields?.length > 0) {
        fields = fields.filter(field => !hiddenMetadataFields.some(hiddenField => field.xml?.DisplayName?.trim().toLowerCase() === hiddenField.trim()));
      }

      if ((!isInfoMode || isCreateFromTemplate) && sharedFieldIds?.length > 0) {
        fields = fields.filter(field => !sharedFieldIds.some(sharedFieldId => field.Id === sharedFieldId));
      }
      else if (isInfoMode && sharedFieldIds?.length > 0) {
        fields = fields.map(field => {
          if (field.xml?.ReadOnly !== SharePointMetadataBooleans.true && sharedFieldIds.some(sharedFieldId => field.Id === sharedFieldId)) {
            field.xml.ReadOnly = SharePointMetadataBooleans.true;
          }
          return field;
        });
      }

      if (isBulkEdit) {
        fields = fields.filter(field => field.InternalName !== sharePointInternalTitleName);
      }

      // Rebuilt from scratch on every field build: setupInputValues pushes one
      // entry per mapped column, so carrying entries over (e.g. after a content
      // type switch) would accumulate stale/duplicate mappings in the cache.
      emailMappings.current = [];
      let inputValuesToSaveFields: SharePointInputData[] = await Promise.all(fields.map(async (item, index) => {
        return await setupInputValues(item, index);
      }));
      inputValuesToSaveFields = addContentTypeMetadataMutation(inputValuesToSaveFields, contentTypeId, false);
      CacheHelper.set(DocubirdCache.spEmailPropertyMappings, emailMappings.current);

      //Typecasting here, because ".key" can be int or string
      const sensitivityLabelId: string = selectedProtectionLabel ? selectedProtectionLabel.key as string : null;
      updateSharepointMetadataToSave(inputValuesToSaveFields, sensitivityLabelId);
      setFields(fields);
      return {
        fields,
        inputValuesToSaveFields
      }
    } else if (!showStaticNameField) {
      const nameField = {
        Choices: undefined,
        CurrentValue: null,
        DefaultValue: null,
        Id: "5cc6dc79-3710-4374-b433-61cb4a686c12",
        InternalName: sharePointInternalFileName,
        isValid: true,
        xml: {
          ColName: "nvarchar8",
          DisplayName: languageStrings.Name,
          ID: "{5cc6dc79-3710-4374-b433-61cb4a686c12}",
          Name: "Name",
          Required: "TRUE",
          Sealed: "TRUE",
          ShowInEditForm: "TRUE",
          ShowInFileDlg: "FALSE",
          ShowInNewForm: "FALSE",
          SourceID: "http://schemas.microsoft.com/sharepoint/v3",
          StaticName: "Name",
          Type: "Text",
        }
      }

      // const titleField = {
      //   Choices: undefined,
      //   CurrentValue: null,
      //   DefaultValue: null,
      //   Id: "5cc6dc79-3710-4374-b433-61cb4a686c12",
      //   InternalName: sharePointInternalTitleName,
      //   isValid: true,
      //   xml: {
      //     ColName: "nvarchar8",
      //     DisplayName: languageStrings.Title,
      //     ID: "{5cc6dc79-3710-4374-b433-61cb4a686c12}",
      //     Name: sharePointInternalTitleName,
      //     Required: "FALSE",
      //     Sealed: "TRUE",
      //     ShowInEditForm: "TRUE",
      //     ShowInFileDlg: "FALSE",
      //     ShowInNewForm: "FALSE",
      //     SourceID: "http://schemas.microsoft.com/sharepoint/v3",
      //     StaticName: sharePointInternalTitleName,
      //     Type: "Text",
      //   }
      // }
      const fields = [nameField];

      emailMappings.current = [];
      const inputValuesToSaveFields: SharePointInputData[] = await Promise.all(fields.map(async (item, index) => {
        return await setupInputValues(item, index);
      }));
      CacheHelper.set(DocubirdCache.spEmailPropertyMappings, emailMappings.current);

      setFields(fields);
      updateSharepointMetadataToSave(inputValuesToSaveFields, null);

      return {
        fields
      }
    }
    return { fields: [] };
  };

  const setupInputValues = async (item, index): Promise<SharePointInputData> => {
    let defaultValue: any;

    let exchangeMailMode: boolean;
    let hasMultipleValuesMapped: boolean;
    let emailMappedProperty: string;

    if (!isInfoMode
      && mode !== ModeEnum.office
      && !DragAndDropHelper.isDroppedModeActive
      && (!generalModule.isInConentMangerMode() || (exchangeMailMode = moveTo.moveToEnabled && (moveTo.mode === ContentManagerCopyMoveModeEnum.CopySelectedEmails || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails)))
      && item?.xml?.DisplayName) {
      const colName = item.xml.DisplayName.trim().toLowerCase(); //directly from sharepoint
      const spColumnNames = emailMapper.getAllListedColumns(); //list of all saved columns we should check for mapping
      const spColumnName = spColumnNames.find(col => col.toLowerCase() === colName); //either returns undefined or a sharepoint column name

      if (spColumnName) {
        // Outlook read mode with multiple emails selected: mailbox.item is null,
        // so the Office.js mapping cannot resolve anything. The headers cached per
        // selected message (OutlookService.getItems) drive the mapping instead,
        // exactly like the content-manager copy-emails flow below.
        // Await the population, not just the cache: opening a save location can
        // race the header load in OutlookService.getItems, and this form reads
        // the mapping exactly once while it is built.
        const outlookMultiSelectItems = !exchangeMailMode
          && !generalModule.isInConentMangerMode()
          && generalModule.getIsOfficeJSAvailable()
          && !Office.context?.mailbox?.item
          ? await getSelectedExchangeItemsAsync()
          : null;

        if (!exchangeMailMode && !(outlookMultiSelectItems?.length > 0)) {
          const mappedValue: IMappedValue = await emailMapper.getSpToEmailMapping(spColumnName, Office?.context?.mailbox, draftEmailHeaders.current ?? mailSendConfig?.headers);
          if (mappedValue?.value) {
            defaultValue = DefaultValueService.setMappedDefault(item, mappedValue);
          }
        }
        else {
          const selectedItems = exchangeMailMode ? await getSelectedExchangeItemsAsync() : outlookMultiSelectItems;
          if (selectedItems) {
            const mappedResult = emailMapper.getOfficeJSToEmailMapping(spColumnName, selectedItems?.length === 1 ? selectedItems[0] : null);
            if (mappedResult) {
              if (selectedItems?.length === 1) {
                defaultValue = DefaultValueService.setMappedDefault(item, mappedResult.mappedVal);
              } else {
                hasMultipleValuesMapped = true;
                emailMappedProperty = mappedResult.mailPropertyName;

                const mapping: ISharePointToEmailMapping = {
                  columnName: item.InternalName,
                  emailProperty: mappedResult.mailPropertyName
                }

                emailMappings.current.push(mapping);
              }
            }
          }
        }
      }
    }

    if (!isBulkEdit && !defaultValue) {
      const folderDefaultValue = locationDefaultValues.current?.find(x => x.fieldName.toLowerCase() === item.InternalName.toLowerCase())?.value;
      defaultValue = DefaultValueService.setValue(item.xml.Type, folderDefaultValue || item.DefaultValue);
    }

    const hasError = !hasMultipleValuesMapped
      && !isBulkEdit
      && (item.xml.Required === SharePointMetadataBooleans.true && !defaultValue);

    return {
      index: index,
      internalName: item.InternalName,
      value: hasMultipleValuesMapped
        ? languageStrings.AutoSetEmailProperty.replace("{emailProperty}", emailMappedProperty)
        : (!isBulkEdit ? defaultValue : undefined),
      hasError,
      type: item.xml.Percentage === SharePointMetadataBooleans.true ? `${item.xml.Type}Percentage` : item.xml.Type,
      displayName: item.xml.DisplayName,
      xml: {
        ...item.xml,
        ReadOnly: hasMultipleValuesMapped ? "TRUE" : item.ReadOnly
      },
      choices: item.Choices
    };
  };

  const setLocationDefaultValues = (defaultValues: ILibraryDefault[]) => {
    if (Array.isArray(defaultValues) && defaultValues.length > 0) {
      const decodedLocation: string = tryDecodeUriComponent(currentDirectory.directory);
      const locationDefaults: ILibraryDefault = defaultValues.find(x => x.folder.endsWith(decodedLocation));

      let libraryDefaults: ILibraryDefaultValue[] = [];
      if (locationDefaults) {

        // Get current location default values
        if (Array.isArray(locationDefaults?.values) && locationDefaults.values.length > 0) {
          libraryDefaults = libraryDefaults.concat(locationDefaults.values);
        }

        // Get all parent structure default values
        const folderUrlParts: string[] = locationDefaults.folder?.split("/");
        if (Array.isArray(folderUrlParts) && folderUrlParts.length > 0) {
          folderUrlParts.pop();
          if (Array.isArray(folderUrlParts) && folderUrlParts.length > 0) {
            let parentFolderUrl = folderUrlParts.join("/");
            let parentDefaults: ILibraryDefault = defaultValues.find(x => x.folder === parentFolderUrl);
            while (parentDefaults) {
              if (Array.isArray(parentDefaults?.values) && parentDefaults.values.length > 0) {
                libraryDefaults = libraryDefaults.concat(parentDefaults.values);
              }
              folderUrlParts.pop();
              if (Array.isArray(folderUrlParts) && folderUrlParts.length > 0) {
                parentFolderUrl = folderUrlParts.join("/");
                parentDefaults = defaultValues.find(x => x.folder === parentFolderUrl);
              }
            }
          }
        }

        locationDefaultValues.current = libraryDefaults;
      }
    }
  }

  const addContentTypeMetadataMutation = (
    inputValuesToSaveFields: SharePointInputData[],
    contentTypeId: string,
    isDefault: boolean
  ) => {
    let result = isDefault
      ? inputValuesToSaveFields
      : [
        ...inputValuesToSaveFields,
        {
          index: inputValuesToSaveFields.length,
          internalName: internalSharepointName.contentTypeId,
          value: contentTypeId,
          hasError: false,
          type: "Content"
        }
      ];

    return result;
  };

  const handleOnChange = async (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
    setFields([]);
    setSelectedContentType(item);
    var accessToken = await authModule.getSharePointAccessToken();
    const { fields, inputValuesToSaveFields } = await getFields(accessToken, documentSetSettings?.sharedFieldIds, item.key as string, item.text);
    if (fieldsChanged) fieldsChanged(fields, item.key as string, inputValuesToSaveFields);
    handleInputChange(inputValuesToSave.length, item.key, false); // last item(index) will always be the content type (inputValuesToSave.length)
  };

  const handleInputChange = (index: number, value: any, hasError: boolean) => {
    const updatedinputValuesToSave = [...inputValuesToSave];
    const changedInput = updatedinputValuesToSave[index];
    const previousName = changedInput?.value;
    changedInput.value = value;
    changedInput.hasError = hasError;

    // Mirror the Title to the Name field as it is edited (create-from-template /
    // multi-file panel), while the Title is still tracking it (unset or equal to
    // the prior name). Mutated in place to match how the Name update above is
    // applied, so the displayed Title stays in sync. A user-typed Title is kept.
    if (shouldSyncTitleFromNameField && changedInput?.internalName === sharePointInternalFileName) {
      const titleIndex = updatedinputValuesToSave.findIndex(x => x.internalName === sharePointInternalTitleName);
      if (titleIndex !== -1) {
        const titleEntry = updatedinputValuesToSave[titleIndex];
        const isMirroringName = titleIsUnset(titleEntry.value, titleAutoSetVariants.current) || titleEntry.value === previousName;
        if (isMirroringName && value && titleEntry.value !== value) {
          titleEntry.value = value;
          titleEntry.hasError = false;
        }
      }
    }

    const sensitivityLabelId: string = selectedProtectionLabel ? selectedProtectionLabel.key as string : null;
    updateSharepointMetadataToSave(updatedinputValuesToSave, sensitivityLabelId, index);
  };

  // Mirror the Title to the Name field while the Title is still tracking it
  // (unset, or equal to the prior name). A Title the user typed is left untouched.
  const syncTitleToName = (previousName: string, newName: string) => {
    if (!newName) {
      return;
    }
    const titleIndex = inputValuesToSave?.findIndex(x => x.internalName === sharePointInternalTitleName);
    if (titleIndex === undefined || titleIndex === -1) {
      return;
    }
    const currentTitle = inputValuesToSave[titleIndex].value;
    const isMirroringName = titleIsUnset(currentTitle, titleAutoSetVariants.current) || currentTitle === previousName;
    if (isMirroringName && currentTitle !== newName) {
      handleInputChange(titleIndex, newName, false);
    }
  };

  // const savingInBackground = <SavingInBackground isOpen={isSavingInBackground} dismissPanel={dismissPanel} />;

  // const onChangeOverWrite = React.useCallback((ev: React.FormEvent<HTMLElement>, checked: boolean): void => {
  //   if (selectedIndividualFile) {
  //     setSelectedIndividualFile({ ...selectedIndividualFile, canOverwrite: checked })
  //   } else {
  //     setFilesCanOverwrite(checked);
  //   }
  // }, [selectedIndividualFile]);

  const handleProtectionLabelChange = async (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) => {
    setSelectedProtectionLabel(item);
    // const sensitivityLabelId: string = (item.key as string)?.length > 0 ? (item.key as string) : null;
    const sensitivityLabelId: string = item.key ? (item.key as string) : null;
    updateSharepointMetadataToSave(inputValuesToSave, sensitivityLabelId);
  };

  const handleTextFieldOnchange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue: string
  ): void => {
    // setOfficeFileName(newValue);
    setSelectedFileName(formatNameFieldValue(newValue));
  };

  const GeneratedFields =
    fields
      .filter(item => item.xml?.Type !== SharePointInputTypes.thumbNail)
      .map((item, index) => {
        let inputValueIndex = inputValuesToSave.findIndex(x => x.internalName === item.InternalName);
        return inputValueIndex !== -1 && item.InternalName !== piiConfig.privacySentitiveColumnName && item.InternalName !== piiConfig.privacySentitiveDataColumnName ? (
          <Stack.Item key={index} >
            <InputMetaDataFactory
              xml={item.xml}
              choices={item.Choices}
              webUrl={itemWebUrl ?? currentDirectory.webUrl}
              sharepointService={sharepointService}
              handleInputChange={handleInputChange}
              inputData={inputValuesToSave[inputValueIndex]}
              internalName={item.InternalName}
              regionalSetting={regionalSettings[itemWebUrl ?? currentDirectory.webUrl]}
              sharepointListId={itemSharepointListId ?? currentDirectory.sharePointListId}
              datasourceFields={datasourceFields}
              containerDisplayNames={containerDisplayNames}
            />
          </Stack.Item>
        ) : null;
      });

  const inputFields = (
    <>
      {!isOneDriveBusiness.current && showUpdateIndividualFilesButton && fileList?.filter(x => x.isSelected === true).length > 1 &&
        <ActionButton
          // iconProps={multipleMetaUpdateIcon}
          // styles={editFilePropertiesButtonStyles}
          onRenderIcon={() => <Edit20Regular />}
          allowDisabledFocus
          onClick={() => {
            setIsCMMultipleFilesMetaDataPanelOpen(true);
          }}
          text={languageStrings.UpdateIndividualFileMetaData}
        />}
      <Stack tokens={stackTokens} style={inputFieldsStackStyles}>
        {showSelectedFileCount && <Stack.Item grow>
          <Stack verticalAlign="center" horizontalAlign="center" styles={loaderStackStyles}>
            <Stack.Item align="center">
              {<Label disabled>{files.filter(x => x.isSelected).length} {languageStrings.FilesSelectedToUpload} </Label>}
            </Stack.Item>
          </Stack>
        </Stack.Item>}
        {!isOneDriveBusiness.current && currentSharepointFolder?.contentTypesEnabled === true && <Stack.Item>
          <Dropdown
            placeholder={languageStrings.SelectOption}
            selectedKey={selectedContentType ? selectedContentType.key : undefined}
            onChange={handleOnChange}
            label={languageStrings.ContentType}
            options={contentTypes}
            className="xb-sp-input"
          // responsiveMode={ResponsiveMode.small}
          />
        </Stack.Item>}
        {showStaticNameField &&
          <Stack horizontal verticalAlign="start" tokens={{ childrenGap: 15 }}>
            <StackItem grow>
              <TextField
                disabled={selectedFileList?.length > 1 || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails || tenantDisableFileRename}
                label={`${languageStrings.Name}`}
                type="text"
                // Entire-folder saves stage no client-side files (the server
                // enumerates the folder and names each message from its
                // subject), so show the same autoset placeholder the Title
                // input shows for that mode instead of an empty box.
                value={selectedFileList?.length > 1 || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyEntireFolderEmails
                  ? languageStrings.TitleAutoSet
                  : selectedFileName}
                onChange={handleTextFieldOnchange}
                required={selectedFileList?.length === 1}
                // Preview of the stored outcome, matching the document list: ".pdf"
                // when the chosen save format converts the file, else its real extension.
                suffix={selectedFileList?.length === 1
                  ? willSaveAsPdf(selectedFileList[0], convertEmailToPDF, saveMode)
                    ? ".pdf"
                    : selectedFileList[0].extension
                      ? `.${selectedFileList[0].extension}`
                      : undefined
                  : undefined}
                errorMessage={selectedFileList?.length === 1 ? (!selectedFileName ? languageStrings.FieldRequired : (selectedFileList[0].isDuplicate ? languageStrings.FileSameName : "")) : null}
                className="xb-sp-input"
              />
            </StackItem>
          </Stack>
        }
        {GeneratedFields}
        {showProtectionDropdown && <Stack.Item>
          <Dropdown
            placeholder={languageStrings.SelectSensitivityLabel}
            selectedKey={selectedProtectionLabel ? selectedProtectionLabel.key : undefined}
            onChange={handleProtectionLabelChange}
            label={languageStrings.Sensitivity}
            options={protectionLabels}
            className="xb-sp-input"
          // responsiveMode={ResponsiveMode.small}
          />
        </Stack.Item>}
        {/* {showCheckbox &&
          <Stack.Item styles={{ root: { marginTop: 20 } }}>
            <Checkbox label={languageStrings.Overwrite} checked={selectedIndividualFile ? selectedIndividualFile.canOverwrite : canOverWrite} onChange={onChangeOverWrite} />
          </Stack.Item>} */}
      </Stack>
    </>
  );

  return isLoading ? <Loader /> : <>{inputFields}</>;
};

export default connector(SaveWithMetaData);
